export const RowColumnGapContainerClasses = {
  GAP_CONTAINER_NONE: ['wf--mx-0'],
  GAP_CONTAINER_SM: ['wf--mx-2', 'overflow-hidden'],
  GAP_CONTAINER_LG: ['wf--mx-4', 'overflow-hidden'],
  GAP_CONTAIER_XL: ['wf--mx-8', 'overflow-hidden']
}